export default "__VITE_ASSET__DW$MnxqY__"